import React, { useState } from 'react'
import { Typography } from '@mui/material'
import { PurchaseLayout } from 'hoc/PurchaseLayout'
import { ConcludedContractsTable } from './ConcludedContractsTable'
import { ConcludedContractsFilters } from './ConcludedContractsFilters'
import { useContractsPublicQuery } from 'services/contracts'
import { useQueryState } from 'react-router-use-location-state'
import { TablePagination } from 'components/TablePagination'
import { Loading } from 'components/Loading'
import { Error } from 'components/Error'
import { useTranslation } from 'react-i18next'

const breadCrumbItems = [
  {
    id: 'home',
    title: 'Ana səhifə',
    path: '/',
  },
  {
    id: 'completed-contracts',
    title: 'Bağlanmış müqavilələr',
  },
]

export type TContractsSearchFilters = {
  contractorOrganizationName?: string
  createdDateFrom?: null | string
  createdDateTo?: null | string
  lotName?: string
}

export const initialFilters: TContractsSearchFilters = {
  contractorOrganizationName: '',
  createdDateFrom: null,
  createdDateTo: null,
  lotName: '',
}

export const ConcludedContracts: React.FC = () => {
  const [filters, setFilters] = useState<TContractsSearchFilters>(initialFilters)
  const [page, setPage] = useQueryState('page', 0)
  const rowsPerPage = 10
  const { t } = useTranslation()

  const args = {
    page,
    size: rowsPerPage,
    contractorOrganizationName: filters.contractorOrganizationName,
    lotName: filters.lotName,
    createdDateFrom: filters.createdDateFrom,
    createdDateTo: filters.createdDateTo,
  } as const
  const { data, isLoading, isError } = useContractsPublicQuery(args, {
    refetchOnMountOrArgChange: true,
  })

  if (isLoading) {
    return <Loading fullPage={false} />
  }
  if (isError) {
    return <Error fullPage={false} />
  }
  if (data === undefined) {
    return <></>
  }

  return (
    <PurchaseLayout breadCrumbItems={breadCrumbItems}>
      <Typography variant="h5">{t('completed-contracts')}</Typography>
      <ConcludedContractsFilters defaultValues={filters} setFilters={setFilters} />
      <ConcludedContractsTable contracts={data.items} />
      {data.info.totalRows !== 0 && (
        <TablePagination
          total={data.info.totalRows}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={setPage}
        />
      )}
    </PurchaseLayout>
  )
}
